<script>
    import gsap from 'gsap';
    import DrawSVGPlugin from 'gsap/DrawSVGPlugin';
    import {onMount, onDestroy} from "svelte";

    gsap.registerPlugin(DrawSVGPlugin);

    let displayNum = 0;

    function interpolate(start, target, durationMS) {
        if (start === target) {
            return;
        }

        const steps = target - start;
        const frameDuration = durationMS / steps;
        const newStart = start + 1;

        displayNum = newStart;

        setTimeout(() => interpolate(newStart, target, durationMS - frameDuration), frameDuration);
    }

    let drawLine;
    let tl = gsap.timeline();
    let svgElement;

    onMount(() => {
        tl.fromTo(drawLine, {
            drawSVG: "100% 100%",
            transformOrigin: 'center center',
        }, {
            drawSVG: "100% 0%",
            stagger: 0.15,
            duration: 1,
            onStart: () => {
                interpolate(0, 56, 1000)
            },
        });

        tl.play();
    });

    onDestroy(() => {
        tl.clear();
        tl = null;
    })
</script>

<svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 380 678" bind:this={svgElement}>
    <defs>
        <clipPath id="clip-path">
            <rect id="Rectangle_596" data-name="Rectangle 596" width="133.189" height="201.63" fill="none"/>
        </clipPath>
    </defs>
    <rect id="Rectangle_866" data-name="Rectangle 866" width="380" height="678"/>
    <text id="Who_is_involved_" data-name="Who is involved?" transform="translate(38 50.446)" fill="#fcd0b1"
          font-size="24" font-family="Metric">
        <tspan x="0" y="0">Who is involved?</tspan>
    </text>
    <text id="CEO" transform="translate(38 100)" fill="#fff" font-size="86" font-family="Metric-Bold, Metric"
          font-weight="700">
        <tspan x="0" y="66">CEO</tspan>
    </text>
    <text id="_56_" data-name="56%" transform="translate(90 287)" fill="#fff" font-size="86"
          font-family="Metric-Bold, Metric" font-weight="700">
        <tspan x="11.937" y="66">{displayNum}%</tspan>
    </text>
    <g id="Group_1192" data-name="Group 1192" transform="translate(-1364 -332)">
        <g id="Group_1193" data-name="Group 1193" transform="translate(1508 561)">
            <g id="Group_1192-2" data-name="Group 1192" clip-path="url(#clip-path)">
                <path bind:this={drawLine} id="Path_14604" data-name="Path 14604" d="M35.4,7.061A96.785,96.785,0,1,1,1,194.337" fill="none"
                      stroke="#008ed2" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                <path id="Path_14605" data-name="Path 14605" d="M30.161,6.6a5.4,5.4,0,1,1,5.4,5.4,5.4,5.4,0,0,1-5.4-5.4"
                      fill="#fff"/>
                <path id="Path_14606" data-name="Path 14606"
                      d="M30.161,6.6a5.4,5.4,0,1,1,5.4,5.4A5.4,5.4,0,0,1,30.161,6.6Z" fill="none" stroke="#100f0c"
                      stroke-miterlimit="10" stroke-width="2.398"/>
            </g>
        </g>
    </g>
    <text id="of_companies_say_the_chief_executive_officer_is_frequently_involved_in_making_strategic_decisions"
          data-name="of companies say the chief executive officer is frequently involved in making strategic decisions"
          transform="translate(38 469)" fill="#fff" font-size="24" font-family="Metric">
        <tspan x="0" y="18">of companies say the</tspan>
        <tspan x="0" y="46">chief executive officer is</tspan>
        <tspan x="0" y="74">frequently involved in</tspan>
        <tspan x="0" y="102">making strategic</tspan>
        <tspan x="0" y="130">decisions</tspan>
    </text>
</svg>
